const roundSavings = (savings) => 5 * Math.round(savings / 5);

class SetSavings extends HTMLElement {
  static observedAttributes = ["percent-savings"];

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
  }

  attributeChangedCallback() {
    this._init();
  }

  get percentSavings() {
    return parseFloat(this.getAttribute("percent-savings") || 0);
  }

  get globalMessage() {
    return this.getAttribute("global-message");
  }

  _init() {
    const roundedSavings = roundSavings(this.percentSavings);

    if (roundedSavings > 0) {
      this.innerHTML = `
        <div class="main-product-details__discount main-product-details__discount--red">
          ${this.globalMessage.replace("[percent_rounded]", roundedSavings)}
        </div>
      `;
      this.style.display = null;
    } else {
      this.innerHTML = "";
      this.style.display = "none";
    }
  }
}

if (!customElements.get("set-savings")) {
  customElements.define("set-savings", SetSavings);
}
